import React, { useEffect, useState } from "react";
import AdminLayout from "./AdminLayout";

const AdminStudentWork = () => {
  const [image, setImage] = useState(null);
  const [data, setData] = useState([]);

  const fetchData = () => {
    fetch("https://kasiaweb.ilakshyaerp.in/api/student")
      .then((res) => res.json())
      .then((res) => setData(Array.isArray(res) ? res : []));
  };

  useEffect(() => {
    fetchData();
  }, []);

  // ✅ FIXED SUBMIT
  const handleSubmit = async () => {
    if (!image) {
      alert("Please select image");
      return;
    }

    const formData = new FormData();
    formData.append("image", image);

    try {
      const res = await fetch("https://kasiaweb.ilakshyaerp.in/api/student/add", {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      // 🔴 SHOW BACKEND ERROR
      if (!res.ok) {
        alert(data.message);
        return;
      }

      // ✅ SUCCESS
      alert(data.message || "Uploaded successfully ✅");

      setImage(null);
      fetchData();

    } catch (err) {
      alert("Server error ❌");
    }
  };

  // ✅ FIXED DELETE
  const handleDelete = async (id) => {
    try {
      const res = await fetch(
        `https://kasiaweb.ilakshyaerp.in/api/student/${id}`,
        { method: "DELETE" }
      );

      const data = await res.json();

      alert(data.message || "Deleted successfully");

      fetchData();

    } catch {
      alert("Delete failed ❌");
    }
  };

  return (
    <AdminLayout>
      <div className="notice-page">

        <div className="notice-card">
          <h2>Add Student Work</h2>

          <input
            type="file"
            accept=".jpg,.jpeg,.png"
            onChange={(e) => setImage(e.target.files[0])}
          />

          <button onClick={handleSubmit}>Upload</button>
        </div>

        <div className="notice-table">
          <h2>Student Work</h2>

          <table>
            <tbody>
              {data.length > 0 ? (
                data.map((d) => (
                  <tr key={d.id}>
                    <td>
                      <img
                        src={`https://kasiaweb.ilakshyaerp.in/uploads/student/${d.image}`}
                        width="100"
                        alt="student work"
                      />
                    </td>

                    <td>
                      <button
                        className="delete-btn"
                        onClick={() => handleDelete(d.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td style={{ textAlign: "center" }}>
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

      </div>
    </AdminLayout>
  );
};

export default AdminStudentWork;